import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IReportRequest } from '../Models/IReportRequest';
import { IReportCSV } from '../Models/IReportCSV';
import { IReportPDF } from '../Models/IReportPDF';
import { IReportRequestExcelBased } from '../Models/IReportRequestExcelBased';
import { IStitchedIEPReportParameter } from '../Models/IStitchedIEPReportParameter';

@Injectable()
export class ReportService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getPDFReport(reportRequest: IReportRequest): Observable<IReportPDF> {
    return this._http.post<IReportPDF>(this._baseUrl + "api/Report/GetServerReport", reportRequest)
      .map((response: IReportPDF) => response as IReportPDF)
      .catch(this.handleError);
  }

  getCSVReport(reportRequest: IReportRequestExcelBased): Observable<IReportCSV> {
    return this._http.post<IReportCSV>(this._baseUrl + "api/Report/GetExcelBasedReport", reportRequest)
      .map((response: IReportCSV) => response as IReportCSV) //'blob')
      .catch(this.handleError);
  }

  getStitchedIEPSummaryPdfReport(iepInstanceIdPSV: string): Observable<IReportPDF> {
    return this._http.get<IReportPDF>(this._baseUrl + `api/Report/GetStitchedIEPSummaryPdfReport?iepInstanceParamsPSV=${iepInstanceIdPSV}`)
      .map((response: IReportPDF) => response as IReportPDF)
      .catch(this.handleError);
  }

  getIepStitchedPdfReport(reportRequest: IStitchedIEPReportParameter): Observable<IReportPDF> {
    return this._http.post<IReportPDF>(this._baseUrl + "api/Report/GetIEPStitchedPdfReport", reportRequest)
      .map((response: IReportPDF) => response as IReportPDF)
      .catch(this.handleError);
  }

  getBlankIepPdfReport(): Observable<IReportPDF> {
    return this._http.get<IReportPDF>(this._baseUrl + "api/Report/GetBlankIepPdfReport")
      .map((response: IReportPDF) => response as IReportPDF)
      .catch(this.handleError);
  }

}
